import React from "react";
import { MessageCircle } from "lucide-react";
import { BUSINESS } from "@/data/site";

const FloatingWA = () => (
  <a
    data-testid="float-wa-btn"
    href={`https://wa.me/91${BUSINESS.primaryWhatsApp}?text=${encodeURIComponent("Hello Chakri Travels, I want to book a car rental service.")}`}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl shadow-[#25D366]/40 ring-4 ring-white/30 transition-transform hover:scale-110 sm:bottom-6 sm:right-6"
  >
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-30"></span>
    <MessageCircle className="relative h-7 w-7" />
  </a>
);

export default FloatingWA;
